import React from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import {SaveInventoryItem} from '../../inventory/utils'

interface ExcludedDetailsDialogProps {
    open: boolean
    selectedItem: SaveInventoryItem | null
    onClose: () => void
    onCopy: (text: string) => void
}

export const ExcludedDetailsDialog = ({
                                   open,
                                   selectedItem,
                                   onClose,
                                   onCopy
                               }: ExcludedDetailsDialogProps) => {
    if (!selectedItem) return null

    return (
        <Dialog open={open} onClose={onClose} sx={{margin: 5, padding: 2}}>
            <DialogTitle sx={{borderBottom: '1px solid #ddd', paddingBottom: 2}}>
                {selectedItem.serial}
            </DialogTitle>
            <DialogContent sx={{padding: 3}}>
                <Typography variant="h6" gutterBottom>
                    <span style={{fontSize: '0.6em'}}>STATUS:</span>
                    <span style={{
                        color: '#d32f2f',
                        fontSize: '1em'
                    }}>{' '}{selectedItem.excluded.split(':')[0]}</span>
                </Typography>
                {!selectedItem.excluded.startsWith('not-found:') && (
                    <Typography variant="h6">
                        <span style={{fontSize: '0.6em'}}>DETAILS:</span>
                        <span style={{
                            color: '#d32f2f',
                            fontSize: '1em'
                        }}>{' '}{selectedItem.excluded.split(':')[1]}</span>
                    </Typography>
                )}
            </DialogContent>
            <DialogActions sx={{justifyContent: 'space-between', padding: 2}}>
                <Button
                    onClick={() => onCopy(selectedItem.excluded.startsWith('not-found:') ? 'not-found' : selectedItem.excluded)}
                    color="primary"
                    startIcon={<ContentCopyIcon />}
                >
                    Copy
                </Button>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}
